import { render, staticRenderFns } from "./PartnerIndex.vue?vue&type=template&id=835215fc&"
import script from "./PartnerIndex.vue?vue&type=script&lang=js&"
export * from "./PartnerIndex.vue?vue&type=script&lang=js&"
import style0 from "./PartnerIndex.vue?vue&type=style&index=0&id=835215fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports